import { datadogRum } from '@datadog/browser-rum';
import { useFlag } from '@unleash/proxy-client-react';

import { useFeatureFlagContext } from '../FeatureFlagContext';
import { FeatureFlags } from '../featureFlags.constants';

/**
 * Hook to check if a feature flag is enabled.
 * Returns false if Unleash is not configured.
 */
export const useFeatureFlag = (flagName: FeatureFlags): boolean => {
  const { isConfigured } = useFeatureFlagContext();
  const isEnabled = useFlag(flagName);

  if (!isConfigured) {
    return false;
  }

  datadogRum.addFeatureFlagEvaluation(flagName, isEnabled);
  return isEnabled;
};
